function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.00012 10.2003L2.50012 6.70031C2.11012 6.31031 1.49012 6.31031 1.10012 6.70031C0.710117 7.09031 0.710117 7.71031 1.10012 8.10031L5.29012 12.2903C5.68012 12.6803 6.31012 12.6803 6.70012 12.2903L17.3001 1.70031C17.6901 1.31031 17.6901 0.690313 17.3001 0.300312C16.9101 -0.0896875 16.2901 -0.0896875 15.9001 0.300312L6.00012 10.2003Z",
  fill: "#27AE60"
});

const SvgTick = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 13,
  viewBox: "0 0 18 13",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTick, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tick.0c20a994.svg";
export { ForwardRef as ReactComponent };